import React from "react"
import {useAccessToken} from "../../services/auth"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {archiveBeneficialOwner, BeneficialOwnerResource} from "../../resources/beneficialOwner"
import {AsyncResultModal} from "../AsyncResultModal/AsyncResultModal"

const modalCloseDelay = 1000

interface RemoveApplicationBeneficialOwnerModalProps {
	bo: BeneficialOwnerResource
	close: () => void
	refresh: () => void
}

function closeAndRefresh(refresh: () => void, close: () => void, delay = 0) {
	return function () {
		setTimeout(() => {
			close()
			refresh()
		}, delay)
	}
}

export default function RemoveApplicationBeneficialOwnerModal({
	bo,
	close,
	refresh,
}: RemoveApplicationBeneficialOwnerModalProps) {
	const accessToken = useAccessToken()
	const [state, archive] = useAsyncResultIdle(archiveBeneficialOwner)

	return (
		<AsyncResultModal
			title="Remove BO"
			close={closeAndRefresh(refresh, close)}
			cancelButtonText="Cancel"
			cancelButtonClassname="button is-white"
			buttonClassname="is-danger is-outlined"
			state={state}
			buttonText="Remove BO"
			successText="Removed"
			onSuccess={closeAndRefresh(refresh, close, modalCloseDelay)}
			onSubmit={() => archive(accessToken, bo)}
			errorToText={(err) => err.errors[0].title}
		>
			Are you sure you want to remove this BO?
		</AsyncResultModal>
	)
}
